// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import PhotoSheetProduct from "./photo-sheet-product.js"
import SheetLayout from "./sheet-layout.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_sheet_product_id": {
      "column": {
        "default": null,
        "name": "photo_sheet_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_sheet_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_layout_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "PhotoSheetProductSheetLayout",
  "collectionKey": "photo_sheet_product_sheet_layouts",
  "collectionName": "photo_sheet_product_sheet_layouts",
  "i18nKey": "photo_sheet_product_sheet_layout",
  "camelizedLower": "photoSheetProductSheetLayout",
  "name": "PhotoSheetProductSheetLayout",
  "nameDasherized": "photo-sheet-product-sheet-layout",
  "pluralName": "photo_sheet_product_sheet_layouts",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_sheet_product_id",
      "column": {
        "default": null,
        "name": "photo_sheet_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "sheet_layout_id",
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    }
  ],
  "paramKey": "photo_sheet_product_sheet_layout",
  "primaryKey": "id"
}

/** Frontend model for PhotoSheetProductSheetLayout. */
export default class PhotoSheetProductSheetLayout extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSheetProductId() {
    return this.readAttributeUnderscore("photo_sheet_product_id")
  }

  /** @returns {boolean} */
  hasPhotoSheetProductId() {
    const value = this.photoSheetProductId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutId() {
    return this.readAttributeUnderscore("sheet_layout_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutId() {
    const value = this.sheetLayoutId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./photo-sheet-product.js").default | null} */
  photoSheetProduct() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProduct, reflectionName: "photo_sheet_product"})
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  loadPhotoSheetProduct() {
    if (!("photoSheetProductId" in this)) throw new Error("Foreign key method wasn't defined: photoSheetProductId")

    const id = this.photoSheetProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product",
        model: this,
        modelClass: PhotoSheetProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  ensurePhotoSheetProductLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product")
  }

  /** @returns {import("./sheet-layout.js").default | null} */
  sheetLayout() {
    return this._readBelongsToReflection({modelClass: SheetLayout, reflectionName: "sheet_layout"})
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  loadSheetLayout() {
    if (!("sheetLayoutId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutId")

    const id = this.sheetLayoutId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout",
        model: this,
        modelClass: SheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  ensureSheetLayoutLoaded() {
    return this.ensureAssociationLoaded("sheet_layout")
  }
}
